import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Logo } from "@/components/common/Logo";
import { ThemeToggle } from "@/components/common/ThemeToggle";

const NAV_LINKS = [
  { label: "Platform", to: "/platform" },
  { label: "Products", to: "/products" },
  { label: "About", to: "/about" },
  { label: "Insights", to: "/insights" },
];

export function TopNav() {
  const { pathname } = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <>
      <header className="fixed top-0 left-0 right-0 z-[110] h-[var(--topnav-height)] backdrop-blur-[10px] bg-[var(--color-surface)]/80 border-b border-[var(--color-border)]">
        {/* Desktop */}
        <div className="hidden md:grid grid-cols-[240px_1fr_auto] h-full">
          <div className="flex items-center justify-start mt-1 px-6">
            <Logo className="[&_img]:h-[28px]" />
          </div>
          <div className="flex items-center justify-center gap-6 px-4">
            {NAV_LINKS.map((item) => {
              const isActive = pathname.startsWith(item.to);
              return (
                <Link
                  key={item.to}
                  to={item.to}
                  className="relative py-1 text-xs font-[family-name:var(--font-mono)] tracking-wider uppercase transition-colors"
                  style={{
                    color: isActive ? "var(--color-fg)" : "var(--color-fg-secondary)",
                  }}
                >
                  {item.label}
                  <span
                    className="absolute -bottom-[1px] left-0 h-[2px] bg-[var(--color-accent)] transition-all duration-300 ease-out"
                    style={{
                      width: isActive ? "100%" : "0%",
                      opacity: isActive ? 1 : 0,
                    }}
                  />
                </Link>
              );
            })}
          </div>
          <div className="flex items-center justify-end gap-4 px-6">
            <ThemeToggle />
            <Link
              to="/contact"
              className="rounded-full border border-[var(--color-border)] px-4 py-1.5 text-xs font-[family-name:var(--font-mono)] tracking-wider uppercase text-[var(--color-fg-secondary)] hover:text-[var(--color-fg)] hover:border-[var(--color-fg-secondary)] transition-colors"
            >
              Get in touch
            </Link>
          </div>
        </div>

        {/* Mobile */}
        <div className="flex md:hidden items-center justify-between h-full px-4">
          <button
            onClick={() => setMenuOpen((v) => !v)}
            className="w-8 h-8 flex items-center justify-center text-[var(--color-fg-secondary)] hover:text-[var(--color-fg)] transition-colors"
            aria-label="Toggle menu"
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
              {menuOpen ? (
                <>
                  <line x1="18" y1="6" x2="6" y2="18" />
                  <line x1="6" y1="6" x2="18" y2="18" />
                </>
              ) : (
                <>
                  <line x1="3" y1="6" x2="21" y2="6" />
                  <line x1="3" y1="12" x2="21" y2="12" />
                  <line x1="3" y1="18" x2="21" y2="18" />
                </>
              )}
            </svg>
          </button>
          <Logo className="[&_img]:h-[24px] mt-0.5" />
          <Link
            to="/contact"
            className="w-8 h-8 flex items-center justify-center text-[var(--color-fg-secondary)] hover:text-[var(--color-fg)] transition-colors"
            aria-label="Contact"
          >
            <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M3 18v-6a9 9 0 0118 0v6" />
              <path d="M21 19a2 2 0 01-2 2h-1a2 2 0 01-2-2v-3a2 2 0 012-2h3zM3 19a2 2 0 002 2h1a2 2 0 002-2v-3a2 2 0 00-2-2H3z" />
            </svg>
          </Link>
        </div>
      </header>

      {/* Mobile dropdown */}
      {menuOpen && (
        <div className="fixed top-[var(--topnav-height)] left-0 right-0 z-[109] md:hidden backdrop-blur-[10px] bg-[var(--color-surface)]/95 border-b border-[var(--color-border)]">
          <nav className="flex flex-col py-2">
            {NAV_LINKS.map((item) => {
              const isActive = pathname.startsWith(item.to);
              return (
                <Link
                  key={item.to}
                  to={item.to}
                  onClick={() => setMenuOpen(false)}
                  className="relative px-6 py-3 text-xs font-[family-name:var(--font-mono)] tracking-wider uppercase transition-colors"
                  style={{
                    color: isActive ? "var(--color-fg)" : "var(--color-fg-secondary)",
                  }}
                >
                  {isActive && (
                    <span className="absolute left-0 top-1/2 -translate-y-1/2 w-[2px] h-4 bg-[var(--color-accent)]" />
                  )}
                  {item.label}
                </Link>
              );
            })}
          </nav>
          <div className="flex items-center justify-between px-6 py-3 border-t border-[var(--color-border)]">
            <ThemeToggle />
            <Link
              to="/contact"
              className="rounded-full border border-[var(--color-border)] px-4 py-1.5 text-xs font-[family-name:var(--font-mono)] tracking-wider uppercase text-[var(--color-fg-secondary)] hover:text-[var(--color-fg)] transition-colors"
            >
              Get in touch
            </Link>
          </div>
        </div>
      )}
    </>
  );
}
